import React, { useEffect, useState, useRef } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ExcelJS from "exceljs";
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";

import AttachmentRed from "../../images/attachment-red.svg";
import AttachmentGreen from "../../images/attachment-green.svg";
import Download from "../../images/Download.svg";
import Print from "../../images/Print.svg";
import { INVOICE_LIST } from "../../constants/RoutePath";
import { useLocation, useNavigate } from "react-router-dom";
import { jsPDF } from "jspdf";
import * as ReactDOMServer from "react-dom/server";
import { AccountCircle } from "@mui/icons-material";
import pdfMainLogo from "../../images/HOS-preview-logo.svg";
import Paper from "@mui/material/Paper";
import {
  GET_INVOICE_REPORT_URL,
  GET_REPOT_BILLING_STATEMENT,
  GET_PROJECT_ROLLUP_HEADERS,
  GET_PROJECT_ROLLUP_BILLING_DETAILS,
  GET_PROJECT_ROLLUP_BILLING_TYPES,
  GET_PROJECT_ROLLUP_BROKER_LIST,
  GET_PROJECT_ROLLUP_BILLING_TREND,
} from "../../constants/ApiRoute";
import API from "../comman/API";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import { authHeader, getStatementId } from "../comman/MainFunction";
const moment = require("moment");
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import html2canvas from "html2canvas";
import htmlDocx from "html-docx-js/dist/html-docx";
import * as XLSX from "xlsx";
import CustomPageLoading from "../comman/CustomPageLoading";

export default function ReportDashboard(props) {
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const lastPart = parts[parts.length - 1];
  const navigate = useNavigate();
  const captureRef = useRef();
  const [fullPageView, setFullPageView] = useState(false);
  const [loading, setLoading] = useState(false);
  const [numPages, setNumPages] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [age, setAge] = React.useState("");
  const [seletedProject, setSeletedProject] = React.useState("");
  const [rollupHeaders, setRollupHeaders] = React.useState("");
  const [rollupBillingDetails, setRollupBillingDetails] = React.useState("");
  console.log(fullPageView, "roloooooooooooooooooooooo");
  const [rollupBillingTypes, setRollupBillingTypes] = React.useState("");
  const [rollupBrokers, setRollupBrokers] = React.useState("");
  const [rollupBillingTrends, setRollupBillingTrends] = React.useState("");
  const [seriessBT, setBTSeries] = useState([]);
  const [labelssBT, setBTLabels] = useState([]);
  const [seriess, setSeriess] = useState([]);
  const [graphConfig, setGraphConfig] = useState({});
  const [downloadType, setDownloadType] = React.useState("Save as");
  const [zoomPgae, setZoomPgae] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  console.log(zoomPgae, "zommmmmmmmmm");
  let lastDisplayedUser = null;

  useEffect(() => {
    if (lastPart) {
      const dashboardParamsdeCrypt = deCryptFun(lastPart);
      const dashboardParamsJson = JSON.parse(dashboardParamsdeCrypt);
      setSeletedProject(dashboardParamsJson);
      console.log("dashboardParamsJson", dashboardParamsJson);
    }
  }, [lastPart]);

  useEffect(() => {
    if (seletedProject && seletedProject.projectId) {
      getProjectRollupHeadersById();
      getProjectRollupBillingDetailsById();
      getProjectRollupBillingTypesById();
      getProjectRollupBrokersById();
      getProjectRollupBillingTrendById();
    }
  }, [seletedProject]);

  const getProjectRollupHeadersById = async () => {
    let data = seletedProject;

    const config = {
      method: "GET",
      url: GET_PROJECT_ROLLUP_HEADERS,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("getProjectRollupHeadersById", parsedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        setRollupHeaders(parsedResponse.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getProjectRollupBillingDetailsById = async () => {
    setLoading(true);
    let data = seletedProject;

    const config = {
      method: "GET",
      url: GET_PROJECT_ROLLUP_BILLING_DETAILS,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("getProjectRollupBillingDetailsById", parsedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        // Group data
        const groupedData = [];
        const seenGroups = new Map();

        parsedResponse.data.forEach((item) => {
          const groupIdentifier = [
            item.ProjID,
            item.UserID,
            item.HeaderID,
            item.BillingStart,
            item.BillingEnd,
          ].join("|");

          if (!seenGroups.has(groupIdentifier)) {
            seenGroups.set(groupIdentifier, {
              ProjID: item.ProjID,
              UserID: item.UserID,
              HeaderID: item.HeaderID,
              UserName: item.UserName,
              UserEmail: item.UserEmail,
              UserPhone: item.UserPhone,
              BillingStart: item.BillingStart,
              BillingEnd: item.BillingEnd,
              BillingStatus: item.BillingStatus,
              data: [],
            });
            groupedData.push(seenGroups.get(groupIdentifier));
          }

          seenGroups.get(groupIdentifier).data.push({
            Description: item.Description,
            DetailDate: item.DetailDate,
            BillingType: item.BillingType,
            DetailHours: item.DetailHours,
            Misc: item.Misc,
            Miles: item.Miles,
            Lodging: item.Lodging,
            Copies: item.Copies,
          });
        });

        console.log("groupedData", groupedData);

        const valuesSort = groupedData?.sort(
          (a, b) => a?.HeaderID - b.HeaderID
        );

        console.log("groupedDatavaluesSort", valuesSort);

        setRollupBillingDetails(valuesSort);
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getProjectRollupBillingTypesById = async () => {
    let data = seletedProject;

    const config = {
      method: "GET",
      url: GET_PROJECT_ROLLUP_BILLING_TYPES,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("getProjectRollupBillingTypesById", parsedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        const seriesData = parsedResponse.data.map(
          (item) => item.BillTypeHours
        );
        const labelsData = parsedResponse.data.map((item) => item.BillingType);
        setBTSeries(seriesData);
        setBTLabels(labelsData);
      }
    } catch (error) {
      setBTSeries([]);
      setBTLabels([]);
      console.log("error", error);
    }
  };

  const getProjectRollupBrokersById = async () => {
    let data = seletedProject;

    const config = {
      method: "GET",
      url: GET_PROJECT_ROLLUP_BROKER_LIST,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("getProjectRollupBrokersById", parsedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        setRollupBrokers(parsedResponse.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getProjectRollupBillingTrendById = async () => {
    let data = seletedProject;

    const config = {
      method: "GET",
      url: GET_PROJECT_ROLLUP_BILLING_TREND,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(data)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      console.log("getProjectRollupBillingTrendById", parsedResponse);

      if (parsedResponse.data && parsedResponse.data.length > 0) {
        const seriesValue = processGraphData(parsedResponse.data);
        setSeriess([seriesValue]);
        console.log(seriesValue, "seriesVluesssssssssssss");

        const graphConfig = {
          chart: {
            height: 380,
            width: "100%",
            type: "bar",
            animations: {
              initialAnimation: {
                enabled: false,
              },
            },
            toolbar: {
              show: false, // Hide the toolbar entirely
            },
          },
          stroke: {
            curve: "smooth",
          },
          series: [seriesValue], // Set series data directly from data array
          // xaxis: {
          //   type: "datetime",
          // },
          xaxis: {
            type: "datetime",
            title: {
              // text: "Date", // Set the x-axis title
              style: {
                fontSize: "12px",
                fontWeight: "normal",
              },
            },

            labels: {
              formatter: function (value) {
                // Convert the timestamp to a UTC date string in 'MM/DD/YYYY' format
                const date = new Date(value);
                return date.toLocaleDateString("en-US", { timeZone: "UTC" });
              },
            },
            // min: (() => {
            //   const now = new Date();
            //   const oneMonthAgo = new Date();
            //   oneMonthAgo.setMonth(now.getMonth() - 1); // Subtract one month from the current date
            //   return oneMonthAgo.getTime(); // Get the timestamp for one month ago
            // })(),
            // max: (() => {
            //   const now = new Date();
            //   return now.getTime(); // Get the current timestamp
            // })(),
          },
          grid: {
            show: true,
            borderColor: "#f9f9f9",
            strokeDashArray: 5, // Make the lines dotted
            // xaxis: {
            //   lines: {
            //     show: true
            //   }
            // },
            yaxis: {
              lines: {
                show: true,
              },
            },
            opacity: 0.1, // Lower the opacity
          },
          plotOptions: {
            bar: {
              columnWidth: "90%", // Increase the column width to make bars wider
            },
          },
        };

        setGraphConfig(graphConfig);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleChange = (event) => {
    setAge(event.target.value);
  };

  const handleChangeZoomPage = (event) => {
    var selectedValue = event.target.value;
    setZoomPgae(selectedValue);
  };

  // Process data to match chart requirements
  const processGraphData = (data) => {
    var series = {
      name: "Hours",
      data: data.map(function (item) {
        const date = new Date(item.Date);
        // Format the date in UTC to avoid local timezone differences
        const formattedDate = date.toISOString().split("T")[0]; // 'YYYY-MM-DD' format in UTC
        return {
          // x: new Date(item.Date).toISOString().split("T")[0] + " GMT",
          x: `${formattedDate}T23:59:00.000Z`,
          y: item.Hours.toFixed("2"),
        };
      }),
    };
    return series;
  };

  const handleChangeDownloadType = (event) => {
    setLoading(true);
    var selectedValue = event.target.value;
    setDownloadType(selectedValue);
    setFullPageView(true);
    setZoomPgae(0);
    setTimeout(() => {
      if (selectedValue === "DOC") {
        textFileDownloadSection();
      } else if (selectedValue === "IMAGE") {
        imageFileDownloadSection();
      } else if (selectedValue === "PDF") {
        pdfFileDownloadSection();
      } else if (selectedValue === "EXCEL") {
        excelFileDownloadSection();
      }
    }, 2000);
  };

  async function imageFileDownloadSection() {
    const element = captureRef.current;

    if (element) {
      // Create a wrapper div with consistent padding
      const wrapper = document.createElement("div");
      wrapper.style.padding = "50px"; // Consistent padding on all sides
      wrapper.style.backgroundColor = "white";
      wrapper.style.boxSizing = "border-box"; // Include padding in dimensions
      wrapper.style.width = `${element.offsetWidth + 100}px`; // Account for padding
      wrapper.style.height = `${element.offsetHeight + 100}px`; // Account for padding

      // Clone the element and its styles
      const clonedElement = element.cloneNode(true);
      copyComputedStyle(element, clonedElement);
      wrapper.appendChild(clonedElement);

      // Append to the document temporarily
      document.body.appendChild(wrapper);

      // Capture the content
      const canvas = await html2canvas(wrapper, {
        useCORS: true,
        scale: 2, // High resolution for better output
        onclone: (documentClone) => {
          documentClone.fonts.ready.then(() => console.log("Fonts loaded"));
        },
      });

      // Convert canvas to PNG and download
      const dataURL = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataURL;
      link.download = "BillingRollup.png";
      link.click();

      // Remove temporary wrapper
      document.body.removeChild(wrapper);

      // Update state
      setFullPageView(false);
      setDownloadType("Save as");
      setLoading(false);
    }
    setLoading(false);
  }

  // Helper function to copy computed styles
  function copyComputedStyle(source, target) {
    const computedStyle = window.getComputedStyle(source);
    for (let prop of computedStyle) {
      target.style[prop] = computedStyle.getPropertyValue(prop);
    }
  }

  const textFileDownloadSection = async () => {
    const captureDiv = document.getElementById("graphImageDiv");
    // const canvas = await html2canvas(captureDiv);
    const canvas = await html2canvas(captureDiv, {
      scale: 0.75, // Improves resolution
      useCORS: true, // Helps load images correctly
      allowTaint: true, // Allows cross-origin images
      logging: false, // Disables unnecessary logs
      backgroundColor: "#ffffff",
    });
    const imgData = canvas.toDataURL("image/png");

    const captureLogo = document.getElementById("pdfMainLogo");
    const canvasLogo = await html2canvas(captureLogo);
    const imgDataLogo = canvasLogo.toDataURL("image/png");

    const openCount =
      rollupHeaders && rollupHeaders[0].OpenCount
        ? parseInt(rollupHeaders[0].OpenCount, 10)
        : 0;
    const closedCount =
      rollupHeaders && rollupHeaders[0].ClosedCount
        ? parseInt(rollupHeaders[0].ClosedCount, 10)
        : 0;

    // Add the values together
    const totalCount = openCount + closedCount;

    const emailTemplate = `
    <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Invoice</title>
</head>
<body style="width: 100%;overflow: visible;font-family: Arial, sans-serif; margin: 0; padding: 0; background-color: #f5f5f5;">

    <div style="width: 800px; margin: 20px auto; background-color: #fff; padding: 20px;">
        <!-- Header -->
          <table style="page-break-inside: avoid; border-collapse: collapse;width: 100%; margin-top: 10px;">
            <tr>
                <td style="text-align: left; padding-right: 10px; vertical-align: top;">
                  <img src="${imgDataLogo}" alt="Logo" height="60px" width="50%"/>
                </td>
                <td style="text-align: right; padding-left: 10px; vertical-align: top;"></td>
              </tr>
          <tr>
            <td style="text-align: left; padding-right: 10px; vertical-align: top;">
                <p style="margin: 0;font-size:15px;font-weight: 700;line-height: 21px;color:#333843;"><b>PROJECT BILLING ROLLUP:</b></p>
                <p style="margin: 0;font-size:15px;font-weight: 400;line-height: 13px;color:#667085;line-break: anywhere;">
                ${
                  rollupHeaders && rollupHeaders[0].ProjID
                    ? rollupHeaders[0].ProjID
                    : ""
                } : 
                ${
                  rollupHeaders && rollupHeaders[0].ProjName
                    ? " " + rollupHeaders[0].ProjName
                    : ""
                }
                </p>
            </td>

            <td style="text-align: right; padding-left: 10px; vertical-align: top;border-right: 4px solid #58A84A;">
                    <!-- Total Due Box -->
                        <p style="margin: 0;font-size:12px;font-weight: 400;line-height: 21px;color: #212121;">TOTAL HOURS:</p>
                        <h2 style="margin: 0;font-size: 24px;font-weight: 700;color:#212121"> <strong> 
                        ${
                          rollupHeaders && rollupHeaders[0].TotalHours
                            ? rollupHeaders[0].TotalHours.toFixed(2)
                            : "0.00"
                        } hours over ${
      rollupHeaders && rollupHeaders[0].TotalDays
        ? rollupHeaders[0].TotalDays
        : "0"
    } days
                        </strong> </h2>
            </td>
            
          </tr>
  </table>

  <br/>


        <!-- Summary Table -->
    <table style="page-break-inside: avoid; border-collapse: collapse;width: 100%; margin-top: 30px; background-color: #f2f2f2;margin-bottom: 10px;border-collapse: collapse;">
        <tr>
        <th style="padding: 0px 10px; font-size: 12px;font-weight: 500;border-right:10px solid #fff;margin-top: 10px;">Open<br>
        <span style="font-size: 12px;font-weight: 400;color: #667085">statement count</span><br>
        <span style=" font-weight: 600;font-size: 14px;line-height: 19.6px;color:#333843;">${
          rollupHeaders && rollupHeaders[0].OpenCount
            ? rollupHeaders[0].OpenCount
            : "0"
        }</span>
        </th>
         <th style="padding: 0px 10px; font-size: 12px;font-weight: 500;border-right:10px solid #fff;margin-top: 10px;">Closed<br>
        <span style="font-size: 12px;font-weight: 400;color: #667085">statement count</span><br>
        <span style=" font-weight: 600;font-size: 14px;line-height: 19.6px;color:#333843;">${
          rollupHeaders && rollupHeaders[0].ClosedCount
            ? rollupHeaders[0].ClosedCount
            : "0"
        }</span>
        </th>
         <th style="padding: 0px 10px; font-size: 12px;font-weight: 500;border-right:10px solid #fff;margin-top: 10px;">Late<br>
        <span style="font-size: 12px;font-weight: 400;color: #667085">statement count</span><br>
        <span style=" font-weight: 600;font-size: 14px;line-height: 19.6px;color:#333843;">${
          rollupHeaders && rollupHeaders[0].LateCount
            ? rollupHeaders[0].LateCount
            : "0"
        }</span>
        </th>
        </tr>
        <tr>
        <th style="border-top: 10px solid #fff;padding: 0px 10px; font-size: 12px;font-weight: 500;border-right:10px solid #fff;margin-top: 10px;">Brokers<br>
        <span style="font-size: 12px;font-weight: 400;color: #667085">brokers count</span><br>
        <span style=" font-weight: 600;font-size: 14px;line-height: 19.6px;color:#333843;">${
          rollupHeaders && rollupHeaders[0].BrokerCount
            ? rollupHeaders[0].BrokerCount
            : "0"
        }</span>
        </th>
        <th style="border-top: 10px solid #fff;padding: 0px 10px; font-size: 12px;font-weight: 500;border-right:10px solid #fff;margin-top: 10px;">Statements<br>
        <span style="font-size: 12px;font-weight: 400;color: #667085">statement count</span><br>
        <span style=" font-weight: 600;font-size: 14px;line-height: 19.6px;color:#333843;">${totalCount}</span>
        </th>
        <th style="border-top: 10px solid #fff;padding: 0px 10px; font-size: 12px;font-weight: 500;border-right:10px solid #fff;margin-top: 10px;">Total Hours<br>
        <span style="font-size: 12px;font-weight: 400;color: #667085">total owed to broker</span><br>
        <span style=" font-weight: 600;font-size: 14px;line-height: 19.6px;color:#333843;">${
          rollupHeaders && rollupHeaders[0].TotalHours
            ? rollupHeaders[0].TotalHours.toFixed(2)
            : "0.00"
        }</span>
        </th>
        </tr>
     </table>
<br>
<center style="width: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;">
  <img src="${imgData}" style=" max-width: 100% !important;
    height: auto !important;">
</center>

    <table style="page-break-inside: avoid;border-collapse: collapse;margin-left:-9px;width: 100%; background-color: #4CAF50; color: white; padding: 10px; border-radius: 5px; border-collapse: collapse;">
        <tr>
          <td style="text-align: left; padding: 5px;">
            <p style="margin: 10px 10px 10px;">Broker Billing Summary</p>
          </td>
        </tr>
      </table>

        <!-- Details Table -->
        <table style="page-break-inside: avoid;border-collapse: collapse;width: 100%; border-collapse: collapse; margin-bottom: 20px;">
            <thead style="background-color: #fff; color: #000;">
                <tr>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">Broker Name</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">Total Hours</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">Total Days</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">Open Count</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">Closed Count</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">Late Count</th>
                </tr>
            </thead>

            <tbody>
      ${
        rollupBrokers &&
        rollupBrokers.length > 0 &&
        rollupBrokers
          .map(
            (val) => `
        <tr style="border-bottom: 1px solid #ddd;">
          <td style="padding: 10px;border-bottom: 1px solid #ededed;word-break:break-all; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">${
              val.BrokerName
            }</td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">${
              val.TotalHours ? val.TotalHours.toFixed(2) : "0.00"
            }</td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">${
              val.TotalDays ? val.TotalDays : 0
            }</td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">${
              val.OpenCount ? val.OpenCount : 0
            }</td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">${
              val.ClosedCount ? val.ClosedCount : 0
            }</td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">${
              val.LateCount ? val.LateCount : 0
            }</td>
        </tr>
      `
          )
          .join("")
      }
    </tbody>


    ${
      rollupBrokers && rollupBrokers.length > 0
        ? `
    <tfoot>
      <tr>
        <td style="border-bottom: 1px solid #ededed;padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">Total</td>
        <td style="border-bottom: 1px solid #ededed;padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">${rollupBrokers.reduce(
            (sum, item) => sum + (item.TotalHours || 0),
            0
          )}</td>
        <td style="border-bottom: 1px solid #ededed;padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">${rollupBrokers
            .reduce((sum, item) => sum + (item.TotalDays || 0), 0)
            .toFixed(2)}</td>
        <td style="border-bottom: 1px solid #ededed;padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">${rollupBrokers
            .reduce((sum, item) => sum + (item.OpenCount || 0), 0)
            .toFixed(2)}</td>
        <td style="border-bottom: 1px solid #ededed;padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">${rollupBrokers
            .reduce((sum, item) => sum + (item.ClosedCount || 0), 0)
            .toFixed(2)}</td>
        <td style="border-bottom: 1px solid #ededed;padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color:#212121;">${rollupBrokers
            .reduce((sum, item) => sum + (item.LateCount || 0), 0)
            .toFixed(2)}</td>
      </tr>
    </tfoot>
    `
        : ``
    }
        </table>

        <br/>


        <div id="capturediv2">
   ${(() => {
     let lastDisplayedUser3 = null; // Initialize outside the loop
     return rollupBillingDetails && rollupBillingDetails.length > 0
       ? rollupBillingDetails
           .map((rollupBilling, index) => {
             const currentUser = `${rollupBilling.UserName} ${rollupBilling.UserEmail} ${rollupBilling.UserPhone}`;
             const shouldDisplay = lastDisplayedUser3 !== currentUser;

             if (shouldDisplay) {
               lastDisplayedUser3 = currentUser; // Update the last displayed user
             }
             return `<div>

        <p style="margin-left:-9px;font-size:15px;font-weight:700;color:#333843;"><strong>
        ${
          shouldDisplay
            ? rollupBilling.UserName +
              " " +
              rollupBilling.UserEmail +
              " " +
              rollupBilling.UserPhone
            : ""
        }
        </strong></p>


        <table style="page-break-inside: avoid;border-collapse: collapse;margin-left:-9px;padding: 10px;width: 100%; border-collapse: collapse; margin-bottom: 20px;broder: 1px solid #EDEDED;">
            <tr>
                <td style="text-align: left;">
                    <p style="padding: 10px; text-align: left;padding-bottom:0px;padding-left:0px;font-size: 12px;
font-style: normal; font-weight:400; line-height: normal;color:#212121;">
                     ${moment
                       .utc(rollupBilling.BillingStart)
                       .format("MM/DD/YYYY")} - ${moment
               .utc(rollupBilling.BillingEnd)
               .format("MM/DD/YYYY")}
                    </p>
                </td>
                <td style="width: 50%; text-align: right;">
                    <p style="padding: 10px; text-align: left;padding-bottom:0px;padding-left:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color:#212121;">
                    Statement ID: ${rollupBilling.HeaderID} - ${
               rollupBilling.BillingStatus
             }
                    </p>
                </td>
            </tr>
        </table>


        <!-- Details Table -->
        <table style="page-break-inside: avoid; border-collapse: collapse;width: 100%; border-collapse: collapse; margin-bottom: 20px;page-break-inside: avoid;
    border-collapse: collapse;">
            <thead style=" background-color: #4CAF50; color: white;">
                <tr>
                    <th style="width: 30%;padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Date</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Type</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Hours</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Lodging</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Copies</th>
                    <th style="padding: 10px; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;">Misc</th>
                </tr>
            </thead>
            <tbody>

            ${
              rollupBilling.data &&
              rollupBilling.data.length > 0 &&
              rollupBilling.data
                .sort((a, b) => new Date(a.DetailDate) - new Date(b.DetailDate))
                .map(
                  (rollupBillingData) => `
        <tr style="border-bottom: 1px solid #ddd;">
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">
            <span>${
              rollupBillingData.DetailDate
                ? moment.utc(rollupBillingData.DetailDate).format("MM/DD/YYYY")
                : "--"
            }</span>
            <br />
            <span style="word-break: break-all;line-break: anywhere;" className="pv-discription">${
              rollupBillingData.Description || "No Description"
            }</span>
          </td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">${
                    rollupBillingData.BillingType
                  }</td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">${rollupBillingData.DetailHours.toFixed(
                    2
                  )}</td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">$${
                    rollupBillingData.Lodging
                      ? rollupBillingData.Lodging.toFixed(2)
                      : "0.00"
                  }</td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">$${
                    rollupBillingData.Copies
                      ? rollupBillingData.Copies.toFixed(2)
                      : "0.00"
                  }</td>
          <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 400; line-height: normal;color: #212121;">$${
                    rollupBillingData.Misc
                      ? rollupBillingData.Misc.toFixed(2)
                      : "0.00"
                  }</td>
        </tr>
      `
                )
                .join("")
            }
            </tbody>

            ${
              rollupBilling.data && rollupBilling.data.length > 0
                ? `
            <tfoot>
            <tr>
            <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color: #212121;" colspan="2">Total</td>
            <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color: #212121;">${rollupBilling.data.reduce(
                    (sum, item) => sum + (item.DetailHours || 0),
                    0
                  )}</td>
            <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color: #212121;">$${rollupBilling.data
                    .reduce((sum, item) => sum + (item.Lodging || 0), 0)
                    .toFixed(2)}</td>
            <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color: #212121;">$${rollupBilling.data
                    .reduce((sum, item) => sum + (item.Copies || 0), 0)
                    .toFixed(2)}</td>
            <td style="padding: 10px;border-bottom: 1px solid #ededed; text-align: left;padding-bottom:0px;font-size: 12px;
font-style: normal; font-weight: 700; line-height: normal;color: #212121;">$${rollupBilling.data
                    .reduce((sum, item) => sum + (item.Misc || 0), 0)
                    .toFixed(2)}</td>
            </tr>
            </tfoot>
            `
                : ""
            }

            
        </table>
      

      </div>
      `;
           })
           .join("") // Join array elements into a single string
       : "";
   })()};

        <!-- Footer -->
        <br />

  <div style="margin-top: 40px; text-align: center; font-size: 12px; color: #777;">
          <p>&copy; 2018 HOS Resources, LLC. All Rights Reserved.
          910 Harding Street, Lafayette, LA 70503.
          337.889.3941 | <a href="https://hosresources.com/" target="_blank">www.hosresources.com</a>
          </p>
  </div>

  <br />
        <table style="page-break-inside: avoid; border-collapse: collapse;width: 100%; background-color: #4CAF50; color: white; padding: 10px; border-radius: 5px; border-collapse: collapse;">
          <tr>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;">910 Harding Street</p>
              <p style="margin: 0;">Lafayette, LA 70503</p>
            </td>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;">P.O. Box 51794</p>
              <p style="margin: 0;">Lafayette, LA 70505</p>
            </td>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;">337.889.3941</p>
            </td>
            <td style="text-align: center; padding: 5px;">
              <p style="margin: 0;">www.hosresources.com</p>
            </td>
          </tr>
        </table>
    </div>

</body>
</html>
    `;

    // Convert the HTML to a DOCX blob
    const converted = htmlDocx.asBlob(emailTemplate);

    // Create a link element
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(converted);
    link.download = "BillingRollUp.docx"; // Specify the file name

    // Programmatically click the link to trigger the download
    link.click();
    setFullPageView(false);
    setLoading(false);
    setDownloadType("Save as");
  };

  async function pdfFileDownloadSection() {
    const emailContent = document.getElementById("reportdiv");

    if (!emailContent) {
      console.error("Element with id 'capturediv' not found!");
      return;
    }

    // Create a canvas from the content using html2canvas
    const canvas = await html2canvas(emailContent, {
      scale: 2,
      useCORS: true,
      width: emailContent.offsetWidth,
      height: emailContent.offsetHeight,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfPageWidth = pdf.internal.pageSize.getWidth(); // A4 width in mm
    const pdfPageHeight = pdf.internal.pageSize.getHeight(); // A4 height in mm
    const padding = 10;

    const imgWidth = pdfPageWidth - 2 * padding; // Deduct padding for image width
    const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

    const sliceHeightPx = Math.floor(
      (pdfPageHeight - 2 * padding) * (canvas.width / imgWidth)
    ); // Slice height in pixels
    let currentHeightPx = 0;

    while (currentHeightPx < canvas.height) {
      const tempCanvas = document.createElement("canvas");
      tempCanvas.width = canvas.width;
      tempCanvas.height = Math.min(
        sliceHeightPx,
        canvas.height - currentHeightPx
      ); // Ensure no overflow beyond canvas height

      const tempCtx = tempCanvas.getContext("2d");

      // Draw the current slice onto the temporary canvas
      tempCtx.drawImage(
        canvas,
        0,
        currentHeightPx,
        canvas.width,
        tempCanvas.height,
        0,
        0,
        tempCanvas.width,
        tempCanvas.height
      );

      const tempImgData = tempCanvas.toDataURL("image/png");

      // Add the slice to the PDF
      pdf.addImage(
        tempImgData,
        "PNG",
        padding,
        padding,
        imgWidth,
        (tempCanvas.height * imgWidth) / tempCanvas.width
      );

      currentHeightPx += tempCanvas.height;

      // Add a new page if more content remains
      if (currentHeightPx < canvas.height) {
        pdf.addPage();
      }
    }

    // Save the PDF
    pdf.save("BillingRollup.pdf");

    // Update the state (if using React)
    setFullPageView(false);
    setDownloadType("Save as");
    setLoading(false);
  }

  const excelFileDownloadSection = () => {
    handleDownloadExcel();
  };

  const handlePrint = () => {
    let printContents = document.getElementById("reportdiv").innerHTML;
    let originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
    setFullPageView(false);
    setDownloadType("Save as");
  };

  //Excel
  const handleDownloadExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();
      const wsData = workbook.addWorksheet("Report");

      const captureChart = async () => {
        const chartElement = document.getElementById("donutChart");
        if (chartElement) {
          const canvas = await html2canvas(chartElement);
          return canvas.toDataURL("image/png"); // Returns a Base64 image
        }
        return null;
      };
      const barCaptureChart = async () => {
        const chartElement = document.getElementById("barChart");
        if (chartElement) {
          const canvas = await html2canvas(chartElement);
          return canvas.toDataURL("image/png"); // Returns a Base64 image
        }
        return null;
      };

      // Page setup
      wsData.pageSetup = {
        paperSize: 32, // A4
        orientation: "portrait",
        fitToPage: true,
      };

      // Column setup
      for (let col = 1; col <= 32; col++) {
        wsData.getColumn(col).width = 15;
        wsData.getColumn(col).alignment = {
          wrapText: false,
          horizontal: "left",
        };
      }

      // Header styling
      wsData.getRow(1).eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
      wsData.getRow(1).height = 30;

      wsData.views = [
        {
          state: "normal",
          showGridLines: false,
        },
      ];

      try {
        const imageUrl =
          "https://hosv2dev.blob.core.windows.net/hosv2dev/HOS-logo_2024-11-29-05-45-04.png?sp=r&st=2024-11-29T19:32:35Z&se=2026-12-31T03:32:35Z&spr=https&sv=2022-11-02&sr=b&sig=vcGmp6ViPLUn73RgVtVmz1NHryyo1uBDmk0ttKqByas%3D";

        console.log("Fetching image from:", imageUrl);
        // Fetch the image as a binary buffer
        const response = await fetch(imageUrl, { method: "GET" });
        if (!response.ok) {
          throw new Error(`Failed to fetch image: ${response.statusText}`);
        }
        const imageBuffer = await response.arrayBuffer();

        // Add the image to the workbook
        const imageId = workbook.addImage({
          buffer: imageBuffer,
          extension: "png",
        });

        // Append the image to the worksheet
        wsData.addImage(imageId, {
          tl: { col: 0, row: 0 }, // Top-left corner where the image starts
          ext: { width: 330, height: 80 }, // Dimensions of the image
        });

        // Add the row for "TOTAL DUE"
        const row = wsData.addRow([
          null, // Leave the first column empty for the image
          null, // Leave the second column empty for the image
          null, // Leave the third column empty for the image
          null, // Leave the first column empty for the image
          null, // Leave the second column empty for the image
          null, // Leave the third column empty for the image
          null, // Leave the first column empty for the image
        ]);

        // Adjust column widths for proper alignment
        wsData.getColumn(1).width = 12; // Image column
        wsData.getColumn(3).width = 25; // Total due column

        console.log("Image successfully added to Excel.");
      } catch (error) {
        console.error("Error fetching or adding image:", error);
        return; // Exit if image addition fails
      }
      wsData.addRow([]);
      wsData.addRow([]);

      // Project Billing Rollup Header
      const openCount = parseInt(rollupHeaders?.[0]?.OpenCount || 0, 10);
      const closedCount = parseInt(rollupHeaders?.[0]?.ClosedCount || 0, 10);
      const totalCount = openCount + closedCount;

      function addStyledCell1(
        row,
        startColumn,
        content,
        mergeColumns = 3,
        gapColumns = 1
      ) {
        const endColumn = startColumn + mergeColumns - 1;

        // Merge cells for the object.
        wsData.mergeCells(row.number, startColumn, row.number, endColumn);

        const cell = row.getCell(startColumn);
        cell.value = { richText: content };
        cell.alignment = {
          wrapText: true,
          vertical: "start",
          horizontal: "center",
        };

        return startColumn + mergeColumns + gapColumns; // Return the next start column.
      }

      const row3 = wsData.addRow([]); // Add an empty row first.
      row3.height = 90;
      let startColumn3 = 1; // Start from the first column.

      startColumn3 = addStyledCell1(row3, startColumn3, [
        {
          text: `${"PROJECT BILLING ROLLUP:"}\n`,
          font: { bold: true },
        },
        {
          text: `${rollupHeaders?.[0]?.ProjID || ""} : ${
            rollupHeaders?.[0]?.ProjName || ""
          }.\n`,
        },
        // {
        //   text: `${rollupHeaders?.[0]?.ProjName || ""},\n`,
        // },
      ]);

      // Add two empty columns as a gap.
      startColumn3 = addStyledCell1(
        row3,
        startColumn3,
        [
          {
            text: "",
          },
        ],
        1,
        0
      ); // 2 columns merged as a gap, no additional gap between.

      // Add the second group of project details (3 columns).
      startColumn3 = addStyledCell1(row3, startColumn3, [
        {
          text: `${"TOTAL HOURS:"}\n`,
        },
        {
          text: `${
            rollupHeaders?.[0]?.TotalHours?.toFixed(2) || "0.00"
          } hours over ${rollupHeaders?.[0]?.TotalDays || "0"} days\n`,
          font: { bold: true },
        },
      ]);

      // Ensure all columns are properly set for visual alignment.
      wsData.columns.forEach((col) => {
        col.width = 15; // Adjust column width to ensure content fits.
      });

      wsData.addRow([]);

      const row = wsData.addRow([]); // Add an empty row first

      // Function to add a cell with merged columns, gap, and border
      function addStyledCell(
        row,
        startColumn,
        content,
        mergeColumns = 2,
        gapColumns = 0
      ) {
        const endColumn = startColumn + mergeColumns - 1;

        // Merge cells for the object
        wsData.mergeCells(row.number, startColumn, row.number, endColumn);

        const cell = row.getCell(startColumn);
        cell.value = { richText: content };
        cell.alignment = {
          wrapText: true,
          vertical: "middle",
          horizontal: "center",
        };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6F7F9" },
        }; // Gray background
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };

        return startColumn + mergeColumns + gapColumns; // Return next start column
      }

      let startColumn = 2; // Start from the first column
      row.height = 50;
      // Total Hours
      startColumn = addStyledCell(row, startColumn, [
        { text: "Open\n", font: { bold: true } },
        { text: "statement count\n" },
        {
          text: `${
            rollupHeaders && rollupHeaders[0].OpenCount
              ? rollupHeaders[0].OpenCount
              : "0"
          }`,
          font: { bold: true },
        },
      ]);

      // Broker Charges
      startColumn = addStyledCell(row, startColumn, [
        { text: "Closed\n", font: { bold: true } },
        {
          text: "statement count\n",
        },
        {
          text: `${
            rollupHeaders && rollupHeaders[0].ClosedCount
              ? rollupHeaders[0].ClosedCount
              : "0"
          }`,
          font: { bold: true },
        },
      ]);

      // Per Diem
      startColumn = addStyledCell(row, startColumn, [
        { text: "Late\n", font: { bold: true } },
        { text: "statement count\n" },
        {
          text: `${
            rollupHeaders && rollupHeaders[0].LateCount
              ? rollupHeaders[0].LateCount
              : "0"
          }`,
          font: { bold: true },
        },
      ]);

      wsData.addRow([]);

      // Add row to the wsData
      const row1 = wsData.addRow([]); // Ensure row1 is initialized
      row1.height = 50;
      if (!row1) {
        throw new Error("Failed to create a row for the wsData.");
      }

      let startColumn1 = 2;

      // Apply formatting to cells
      startColumn1 = addStyledCell(row1, startColumn1, [
        { text: "Brokers\n", font: { bold: true } }, // Expenses column
        { text: "broker count\n" },
        {
          text: `${
            rollupHeaders && rollupHeaders[0].BrokerCount
              ? rollupHeaders[0].BrokerCount
              : "0"
          }`,
          font: { bold: true },
        },
      ]);

      startColumn1 = addStyledCell(row1, startColumn1, [
        { text: "Statements\n", font: { bold: true } }, // Miles column
        {
          text: "statement count\n",
        },
        {
          text: `${totalCountStatemnts}`,
          font: { bold: true },
        },
      ]);

      startColumn1 = addStyledCell(row1, startColumn1, [
        { text: "Total Hours\n", font: { bold: true } }, // Total Owed column
        { text: "total owed to broker\n" },
        {
          text: `${
            rollupHeaders && rollupHeaders[0].TotalHours
              ? rollupHeaders[0].TotalHours.toFixed(2)
              : "0.00"
          }`,
          font: { bold: true },
        },
      ]);

      wsData.addRow([]);
      wsData.addRow([]);

      const chartImage = await captureChart();
      const chartBarImage = await barCaptureChart();

      const imageId = workbook.addImage({
        base64: chartImage,
        extension: "png",
      });

      const imageId1 = workbook.addImage({
        base64: chartBarImage,
        extension: "png",
      });

      // Add the image to the wsData
      wsData.addImage(imageId, {
        tl: { col: 0, row: 10 }, // Top-left corner of the image
        ext: { width: 300, height: 250 }, // Dimensions of the image
      });
      wsData.addImage(imageId1, {
        tl: { col: 5, row: 10 }, // Top-left corner of the image
        ext: { width: 300, height: 200 }, // Dimensions of the image
      });

      wsData.addRow([]);
      wsData.addRow([]);
      wsData.addRow([]);

      function addStyledCell2(
        row,
        startColumn,
        content,
        mergeColumns = 2,
        gapColumns = 1
      ) {
        const endColumn = startColumn + mergeColumns - 1;

        // Merge cells for the object.
        wsData.mergeCells(row.number, startColumn, row.number, endColumn);

        // Get the first cell in the merged range to apply styling.
        const cell = row.getCell(startColumn);
        cell.value = { richText: content };
        cell.alignment = {
          wrapText: true,
          vertical: "start",
          horizontal: "left",
        };

        // Apply background color to the merged range.
        for (let col = startColumn; col <= endColumn; col++) {
          const currentCell = row.getCell(col);
          currentCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "58a84a" },
          }; // Green background
        }

        return startColumn + mergeColumns + gapColumns; // Return next start column.
      }

      // Access row 19 directly and apply the styled cell function.
      const row19 = wsData.getRow(25); // Access row 19 directly.
      row19.height = 15; // Set the height for row 19.
      let startColumn19 = 1;

      // Add a cell that spans 8 columns and has a background color.
      startColumn19 = addStyledCell2(
        row19,
        startColumn19,
        [
          {
            text: "Broker Billing Summary\n",
            font: { bold: true },
          },
        ],
        7 // Merge 8 columns.
      );

      // Commit the changes to row 19.
      row19.commit();

      wsData.addRow([]);

      // Broker Billing Summary
      const summaryHeadrs = wsData.addRow([
        "Broker Name",
        "",
        "Total Hours",
        "Total Days",
        "Open Count",
        "Closed Count",
        "Late Count",
      ]);

      summaryHeadrs.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "58a84a" }, // Light gray color (use hex ARGB format)
        };
        cell.font = {
          bold: true, // Optional: Make the text bold for better visibility
          color: { argb: "FFFFFFFF" },
        };
        cell.alignment = {
          vertical: "middle", // Center vertically
          horizontal: "center", // Center horizontally
        };
      });

      rollupBrokers?.forEach((broker) => {
        const tableRow = wsData.addRow([
          broker.BrokerName,
          "",
          broker.TotalHours?.toFixed(2) || "0.00",
          broker.TotalDays || "0",
          broker.OpenCount || "0",
          broker.ClosedCount || "0",
          broker.LateCount || "0",
        ]);

        const row = wsData.getRow(tableRow.number);
        row.height = 30; // Adjust as needed for better visibility of wrapped text

        // Format each cell in the row
        tableRow.eachCell((cell, colNumber) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            horizontal: "center",
            wrapText: true, // Wrap text only for the "Description" column
          };
        });
      });

      // Totals Row
      const totalValues = wsData.addRow([
        "Total",
        "",
        rollupBrokers
          ?.reduce((sum, b) => sum + (b.TotalHours || 0), 0)
          .toFixed(2),
        rollupBrokers
          ?.reduce((sum, b) => sum + (b.TotalDays || 0), 0)
          .toFixed(2),
        rollupBrokers
          ?.reduce((sum, b) => sum + (b.OpenCount || 0), 0)
          .toFixed(2),
        rollupBrokers
          ?.reduce((sum, b) => sum + (b.ClosedCount || 0), 0)
          .toFixed(2),
        rollupBrokers
          ?.reduce((sum, b) => sum + (b.LateCount || 0), 0)
          .toFixed(2),
      ]);

      totalValues.eachCell((cell) => {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      wsData.getRow(totalValues.number).eachCell((cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.font = { bold: true, color: { argb: "000000" } }; // Example formatting for emphasis
      });

      let lastDisplayedUser1 = null;
      // Rollup Billing Details
      rollupBillingDetails?.forEach((detail) => {
        // Get the current user's unique string
        // Safely extract user details and format them consistently
        const currentUser = `${detail.UserName?.trim() || "N/A"}  ${
          detail.UserEmail?.trim() || "N/A"
        }  ${detail.UserPhone?.trim() || "N/A"}`;

        // Check if the current user is different from the last displayed user
        const shouldDisplay = lastDisplayedUser1 !== currentUser;

        if (shouldDisplay) {
          wsData.addRow([]);
          // Update the last displayed user
          lastDisplayedUser1 = currentUser;

          // Add a new row for the user details
          const userDetailsRow = wsData.addRow([
            "",
            "",
            "",
            "",
            "",
            "",
            "",
            "",
          ]); // Placeholder cells

          // Merge cells from columns A to H in the new row
          wsData.mergeCells(
            `A${userDetailsRow.number}:H${userDetailsRow.number}`
          );

          // Get the first cell of the merged range
          const mergedCell = wsData.getCell(userDetailsRow.number, 1);

          // Set the cell value to display the user's details
          mergedCell.value = currentUser;

          // Apply styling to the merged cell
          mergedCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "d9d9d9" }, // Light gray background
          };
          mergedCell.font = {
            bold: true, // Make the text bold for emphasis
            color: { argb: "000000" }, // Black text color
          };
          mergedCell.alignment = {
            vertical: "middle",
            horizontal: "left", // Align the text to the left
            wrapText: true, // Ensure the text wraps if it is long
          };

          // Adjust row height for the user details row
          userDetailsRow.height = 30;
        }
        // Adjust column widths as necessary to fit the content
        wsData.getColumn(1).width = 15; // Adjust column width as needed
        wsData.getColumn(2).width = 15;
        wsData.getColumn(3).width = 15;
        wsData.getColumn(4).width = 15;
        wsData.getColumn(5).width = 15;
        wsData.getColumn(6).width = 15;
        wsData.getColumn(7).width = 15;

        wsData.addRow([]);

        // After adding the total values row
        const totalValuesRow = wsData.getRow(wsData.lastRow.number); // Get the last row after total values
        const nextRowNumber = totalValuesRow.number + 1; // Calculate the next row number

        // Use the calculated row number for `row25`
        const row25 = wsData.getRow(nextRowNumber); // Get the row at the next available position

        // Set the height for row25
        row25.height = 15;

        // Function to style individual cells without merging
        function styleBackgroundCells(row, startColumn, columns) {
          for (let col = startColumn; col < startColumn + columns; col++) {
            const cell = row.getCell(col);
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "F6F7F9" }, // Gray background for each column
            };
            cell.border = {
              top: { style: "thin" },
              // left: { style: "thin" },
              bottom: { style: "thin" },
              // right: { style: "thin" },
            };
          }
        }

        // Function to add styled cells and return the next column index
        function addStyledCellTable(
          row,
          startColumn,
          content,
          mergeColumns = 3
        ) {
          const endColumn = startColumn + mergeColumns - 1;

          console.log("Start Column:", startColumn);
          console.log("End Column:", endColumn);

          // Check if the column indices are valid (greater than 0)
          if (startColumn < 1 || endColumn < 1) {
            throw new Error(
              `Invalid column index. Start: ${startColumn}, End: ${endColumn}`
            );
          }

          // Merge cells for the object
          wsData.mergeCells(row.number, startColumn, row.number, endColumn);

          const cell = row.getCell(startColumn);
          cell.value = { richText: content };
          cell.alignment = {
            wrapText: true,
            vertical: "start",
            horizontal: "left",
          };
          return startColumn + mergeColumns; // Return next start column
        }

        // Add background color for 7 columns
        styleBackgroundCells(row25, 1, 8);

        // Add the first object (📅...) to the first 2 columns
        let startColumn25 = 1;
        startColumn25 = addStyledCellTable(row25, startColumn25, [
          {
            text: `📅${moment
              .utc(detail.BillingStart)
              .format("MM/DD/YYYY")} - ${moment
              .utc(detail.BillingEnd)
              .format("MM/DD/YYYY")}\n`,
          },
        ]);

        // Skip 2 columns for the gap
        startColumn25 += 2;

        // Add the second object (Statement ID...) to the next 2 columns
        startColumn25 = addStyledCellTable(row25, startColumn25, [
          {
            text: `Statement ID: ${detail.HeaderID} - ${detail.BillingStatus}\n`,
          },
        ]);

        // Add empty rows for spacing
        wsData.addRow([]);
        const headersCss = wsData.addRow([
          "Date",
          "Type",
          "Hours",
          "Lodging",
          "Copies",
          "Misc",
          "Description", // Placeholder for the first part of Description
          "", // Placeholder for the second part of Description
        ]);

        // Merge the "Description" header across two columns
        const descriptionHeaderStartColumn = 7;
        const descriptionHeaderEndColumn = 8;
        wsData.mergeCells(
          headersCss.number,
          descriptionHeaderStartColumn,
          headersCss.number,
          descriptionHeaderEndColumn
        );

        // Style each header cell
        headersCss.eachCell((cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "58a84a" }, // Light gray color (use hex ARGB format)
          };
          cell.font = {
            bold: true, // Optional: Make the text bold for better visibility
            color: { argb: "FFFFFFFF" }, // White font color
          };
          cell.alignment = {
            vertical: "middle", // Center vertically
            horizontal: "center", // Center horizontally
          };
        });

        // Apply additional styles for the Description header column
        const descriptionHeaderCell = headersCss.getCell(
          descriptionHeaderStartColumn
        );
        descriptionHeaderCell.alignment = {
          vertical: "middle",
          horizontal: "center",
          wrapText: true,
        };

        // Adjust the width of the merged "Description" column
        wsData.getColumn(descriptionHeaderStartColumn).width = 40; // Adjust width for the first part
        wsData.getColumn(descriptionHeaderEndColumn).width = 0; // Hide the second part if necessary

        detail.data?.forEach((entry) => {
          // Add a new row with placeholders for all columns
          const tableRow = wsData.addRow([
            entry.DetailDate
              ? moment.utc(entry.DetailDate).format("MM/DD/YYYY")
              : "--",
            entry.BillingType || "Unknown",
            entry.DetailHours || "0.00",
            entry.Lodging?.toFixed(2) || "0.00",
            entry.Copies?.toFixed(2) || "0.00",
            entry.Misc?.toFixed(2) || "0.00",
            "", // Placeholder for Description part 1
            "", // Placeholder for Description part 2
          ]);

          // Set the row height dynamically if necessary
          const row = wsData.getRow(tableRow.number);
          row.height = 30; // Adjust as needed for better visibility of wrapped text

          // Merge the last two columns for the "Description"
          const descriptionStartColumn = 7; // Adjust index if columns change
          const descriptionEndColumn = 8;
          wsData.mergeCells(
            row.number,
            descriptionStartColumn,
            row.number,
            descriptionEndColumn
          );

          // Get the first cell of the merged range and set the Description value
          const descriptionCell = row.getCell(descriptionStartColumn);
          descriptionCell.value = entry.Description || "No Description";

          // Apply formatting for all cells in the row
          tableRow.eachCell((cell, colNumber) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
            console.log(colNumber, descriptionStartColumn);
            cell.alignment = {
              vertical: "middle",
              horizontal:
                colNumber === descriptionStartColumn ? "left" : "center", // Left-align Description
              wrapText: true, // Wrap text only for the "Description" column
            };
          });
        });

        // Add the Total row
        const totalValues = wsData.addRow([
          "Total",
          "",
          `${detail.data.reduce(
            (sum, item) => sum + (item.DetailHours || 0),
            0
          )}`,
          `$${detail.data
            .reduce((sum, item) => sum + (item.Lodging || 0), 0)
            .toFixed(2)}`,
          `$${detail.data
            .reduce((sum, item) => sum + (item.Copies || 0), 0)
            .toFixed(2)}`,
          `$${detail.data
            .reduce((sum, item) => sum + (item.Misc || 0), 0)
            .toFixed(2)}`,
          "", // Placeholder for merged columns
          "", // Placeholder for merged columns
        ]);

        // Merge the last two columns for the "Total" row
        const lastColumnStartIndex = 7; // Assuming the last two columns are 7 and 8
        const lastColumnEndIndex = 8;
        wsData.mergeCells(
          totalValues.number,
          lastColumnStartIndex,
          totalValues.number,
          lastColumnEndIndex
        );

        // Style the merged cells
        wsData.getRow(totalValues.number).eachCell((cell) => {
          cell.alignment = { vertical: "middle", horizontal: "center" };
          cell.font = { bold: true, color: { argb: "000000" } }; // Example formatting for emphasis
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
        });

        wsData.addRow([]);
      });

      wsData.addRow([]);
      wsData.addRow([]);

      wsData.addRow([
        `© 2018. HOS Resources, LLC. All Rights Reserved. 910 Harding Street Lafayette, LA 70503 337-296-8032 www.hosresources.com`,
      ]);
      wsData.addRow([]);

      const officeDetails = wsData.addRow([
        "📍 910 Harding Street\nLafayette, LA 70503", // Value spans columns 1 and 2
        "", // Placeholder for merging with column 1
        "📬 P.O. Box 51794\nLafayette, LA 70505", // Value spans columns 3 and 4
        "", // Placeholder for merging with column 3
        "📞 337.889.3941", // Value spans columns 5 and 6
        "", // Placeholder for merging with column 5
        "🌐 www.hosresources.com", // Last column
      ]);

      // Merge cells to span the content across two columns
      wsData.mergeCells(officeDetails.number, 1, officeDetails.number, 2); // Merge columns 1 and 2
      wsData.mergeCells(officeDetails.number, 3, officeDetails.number, 4); // Merge columns 3 and 4
      wsData.mergeCells(officeDetails.number, 5, officeDetails.number, 6); // Merge columns 5 and 6
      wsData.mergeCells(officeDetails.number, 7, officeDetails.number, 8); // Merge columns 5 and 6

      // Apply styling to each cell in the row
      officeDetails.eachCell((cell, colNumber) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "58a84a" }, // Background color (green)
        };
        cell.font = {
          bold: true,
          color: { argb: "FFFFFFFF" }, // White font color
        };

        cell.alignment = {
          vertical: "middle",
          horizontal: "center", // Center content horizontally
          wrapText: true, // Wrap text for all cells
        };
      });

      officeDetails.height = 30;

      // Optionally, adjust column widths for better display
      wsData.columns.forEach((col) => {
        col.width = 15; // Adjust as needed for content visibility
      });

      try {
        // Write to file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "BillingRollup.xlsx";
        a.click();
      } catch (error) {
        console.error("Error writing Excel file:", error);
      }
      setLoading(false);
      setFullPageView(false);
      setDownloadType("Save as");
    } catch (error) {
      console.error("Error exporting file:", error);
      setLoading(false);
      setFullPageView(false);
      setDownloadType("Save as");
    }
  };

  const pageLoad = () => {
    if (seletedProject && seletedProject.projectId) {
      setCurrentPage(0);
      setZoomPgae(0);
      setFullPageView(false);
      setDownloadType("Save as");
      getProjectRollupHeadersById();
      getProjectRollupBillingDetailsById();
      getProjectRollupBillingTypesById();
      getProjectRollupBrokersById();
      getProjectRollupBillingTrendById();
    }
  };

  const itemsPerPage = 2;

  // Calculate the total number of pages
  const totalPages = Math.ceil(rollupBillingDetails.length / itemsPerPage);

  const currentPageData = rollupBillingDetails.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  console.log(currentPageData, "currentPageDatacurrentPageData");

  // Navigation handlers
  const handleNextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 0) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(0);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages - 1);
  };

  const openCount =
    rollupHeaders && rollupHeaders[0].OpenCount
      ? parseInt(rollupHeaders[0].OpenCount, 10)
      : 0;
  const closedCount =
    rollupHeaders && rollupHeaders[0].ClosedCount
      ? parseInt(rollupHeaders[0].ClosedCount, 10)
      : 0;

  // Add the values together
  const totalCountStatemnts = openCount + closedCount;

  return (
    <div id="samplechk">
      <Box sx={{ display: "-webkit-box" }}>
        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Box className="bg-box invoicepdfbg-box">
            <Grid className="pdf-top-header" container spacing={2}>
              <Grid
                sx={{ pt: "0px !important", my: "auto" }}
                item
                xs={12}
                md={7}
              >
                <Stack alignItems="center" direction="row" spacing={2}>
                  <span
                    className="material-symbols-outlined"
                    onClick={handleFirstPage}
                    disabled={currentPage == 0}
                    style={{
                      cursor: currentPage == 0 ? "" : "pointer",
                      color: currentPage == 0 ? "lightgray" : "",
                    }}
                  >
                    skip_previous
                  </span>
                  <span
                    className="material-symbols-outlined"
                    style={{
                      cursor: currentPage == 0 ? "" : "pointer",
                      color: currentPage == 0 ? "lightgray" : "",
                    }}
                    onClick={handlePreviousPage}
                    disabled={currentPage == 0}
                  >
                    chevron_left
                  </span>
                  <span className="pagination-text active-num">
                    {currentPage + 1}
                  </span>
                  <span className="pagination-text">of {totalPages}</span>
                  <span
                    className="material-symbols-outlined"
                    style={{
                      cursor: totalPages - 1 === currentPage ? "" : "pointer",
                      color: totalPages - 1 === currentPage ? "lightgray" : "",
                    }}
                    onClick={handleNextPage}
                    disabled={totalPages - 1 === currentPage}
                  >
                    chevron_right
                  </span>
                  <span
                    style={{
                      cursor: totalPages - 1 === currentPage ? "" : "pointer",
                      color: totalPages - 1 === currentPage ? "lightgray" : "",
                    }}
                    className="material-symbols-outlined"
                    onClick={handleLastPage}
                    disabled={totalPages - 1 === currentPage}
                  >
                    skip_next
                  </span>
                  <span
                    className="material-symbols-outlined reload-pdf"
                    onClick={pageLoad}
                    style={{ cursor: "pointer" }}
                  >
                    refresh
                  </span>
                  {/* <span className="material-symbols-outlined"
                  onClick={() => {
                    navigate(`/dashboard`);
                  }}>arrow_back</span> */}
                </Stack>
              </Grid>
              <Grid sx={{ pt: "0px !important" }} item xs={12} md={5}>
                <Stack direction="row" spacing={0}>
                  <FormControl className="whole-select" fullWidth>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // value={age}
                      // onChange={handleChange}
                      value={zoomPgae}
                      onChange={handleChangeZoomPage}
                    >
                      <MenuItem value={0.01}>Whole Page</MenuItem>
                      <MenuItem value={500}>500 %</MenuItem>
                      <MenuItem value={200}>200 %</MenuItem>
                      <MenuItem value={150}>150 %</MenuItem>
                      <MenuItem value={0}>100 %</MenuItem>
                      <MenuItem value={-10}>75 %</MenuItem>
                      <MenuItem value={-25}>50 %</MenuItem>
                      <MenuItem value={-50}>25 %</MenuItem>
                      <MenuItem value={-75}>10 %</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl className="saveas-btn" fullWidth>
                    <Select
                      id="demo-simple-select"
                      startAdornment={
                        <InputAdornment position="start">
                          <span className="material-symbols-outlined">
                            save
                          </span>
                        </InputAdornment>
                      }
                      value={downloadType}
                      onChange={handleChangeDownloadType}
                    >
                      <MenuItem value={"Save as"}>Save as</MenuItem>
                      <MenuItem value={"PDF"}>PDF</MenuItem>
                      <MenuItem value={"EXCEL"}>EXCEL</MenuItem>
                      <MenuItem value={"DOC"}>WORD</MenuItem>
                      <MenuItem value={"IMAGE"}>IMAGE</MenuItem>
                    </Select>
                  </FormControl>
                  <Button
                    className="primary-btn save-print-btn"
                    onClick={() => {
                      setFullPageView(true);
                      setTimeout(() => {
                        handlePrint();
                      }, 2000);
                    }}
                  >
                    <span className="material-symbols-outlined">print</span>
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <div
              style={
                zoomPgae
                  ? {
                      overflow: "scroll",
                      width: "100%",
                      height: "100%",
                      backgroundColor: "#fff",
                    }
                  : {}
              }
            >
              <div
                ref={captureRef}
                id="reportdiv"
                style={
                  zoomPgae
                    ? {
                        transform: `scale(${zoomPgae / 100 + 1})`,
                        transformOrigin: "0 0",
                      }
                    : {}
                }
              >
                <div id="capturediv">
                  <Stack
                    sx={{ mt: "27px" }}
                    direction="row"
                    justifyContent="space-between"
                    spacing={2}
                  >
                    <img src={pdfMainLogo} id="pdfMainLogo" />
                  </Stack>
                  <hr
                    style={{ border: "1px solid #E3E5E8", margin: "20px 0px" }}
                  />
                  <Table
                    className="A4-print-table"
                    sx={{
                      border: "none",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <Typography className="address-title">
                            PROJECT BILLING ROLLUP:
                          </Typography>
                          <Typography className="address-text">
                            {rollupHeaders && rollupHeaders[0].ProjID
                              ? rollupHeaders[0].ProjID
                              : ""}{" "}
                            :
                            {rollupHeaders && rollupHeaders[0].ProjName
                              ? " " + rollupHeaders[0].ProjName
                              : ""}
                          </Typography>
                        </TableCell>
                        <TableCell sx={{ textAlign: "right" }}>
                          <Box
                            sx={{
                              borderRight: "4px solid green",
                              paddingRight: "10px",
                              mt: "auto !important",
                              mb: "auto !important",
                            }}
                          >
                            <Typography className="total-due">
                              TOTAL HOURS:
                            </Typography>
                            <Typography className="total-amount">
                              {rollupHeaders && rollupHeaders[0].TotalHours
                                ? rollupHeaders[0].TotalHours.toFixed(2)
                                : "0.00"}{" "}
                              hours over{" "}
                              {rollupHeaders && rollupHeaders[0].TotalDays
                                ? rollupHeaders[0].TotalDays
                                : "0"}{" "}
                              days
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>

                  <Table
                    className="A4-print-table"
                    sx={{
                      mt: "30px",
                      border: "none",
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <Box className="statement-box">
                            <Typography className="stm-title">Open</Typography>
                            <Typography className="stm-text">
                              statement count
                            </Typography>
                            <Typography className="stm-count">
                              {rollupHeaders && rollupHeaders[0].OpenCount
                                ? rollupHeaders[0].OpenCount
                                : "0"}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className="statement-box">
                            <Typography className="stm-title">
                              Closed
                            </Typography>
                            <Typography className="stm-text">
                              statement count
                            </Typography>
                            <Typography className="stm-count">
                              {rollupHeaders && rollupHeaders[0].ClosedCount
                                ? rollupHeaders[0].ClosedCount
                                : "0"}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className="statement-box">
                            <Typography className="stm-title">Late</Typography>
                            <Typography className="stm-text">
                              statement count
                            </Typography>
                            <Typography className="stm-count">
                              {rollupHeaders && rollupHeaders[0].LateCount
                                ? rollupHeaders[0].LateCount
                                : "0"}
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Box className="statement-box">
                            <Typography className="stm-title">
                              Brokers
                            </Typography>
                            <Typography className="stm-text">
                              broker count
                            </Typography>
                            <Typography className="stm-count">
                              {rollupHeaders && rollupHeaders[0].BrokerCount
                                ? rollupHeaders[0].BrokerCount
                                : "0"}
                            </Typography>
                          </Box>
                        </TableCell>

                        <TableCell>
                          <Box className="statement-box">
                            <Typography className="stm-title">
                              Statements
                            </Typography>
                            <Typography className="stm-text">
                              statement count
                            </Typography>
                            <Typography className="stm-count">
                              {totalCountStatemnts}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box className="statement-box">
                            <Typography className="stm-title">
                              Total Hours
                            </Typography>
                            <Typography className="stm-text">
                              total owed to broker
                            </Typography>
                            <Typography className="stm-count">
                              {rollupHeaders && rollupHeaders[0].TotalHours
                                ? rollupHeaders[0].TotalHours.toFixed(2)
                                : "0.00"}
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                  <Table
                    className="A4-print-table"
                    spacing={2}
                    sx={{ mt: "30px", border: "none" }}
                    id="graphImageDiv"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <Box id="donutChart">
                            <Typography className="dash-chart-title">
                              Hours Billed Per Billing Type
                            </Typography>
                            <div className="report-avg-graph" id="chart">
                              <ReactApexChart
                                // style={{ minHeight: "300px" }}
                                options={{
                                  labels: labelssBT,
                                }}
                                series={seriessBT}
                                type="donut"
                              />
                            </div>
                            <div id="html-dist"></div>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Box id="barChart">
                            <Typography className="dash-chart-title">
                              Billing Trend (hours by day)
                            </Typography>
                            <div id="chart">
                              <ReactApexChart
                                options={graphConfig}
                                // options={barChartConfig}
                                series={seriess}
                                type="bar"
                                height={300}
                              />
                            </div>
                            <div id="html-dist"></div>
                          </Box>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                  <Typography
                    sx={{ mt: "30px !important" }}
                    className="billing-summary-title"
                  >
                    Broker Billing Summary
                  </Typography>
                  <TableContainer
                    sx={{ minHeight: "270px" }}
                    className="preview-table summary-table"
                    component={Paper}
                  >
                    <Table
                      sx={{
                        minWidth: 650,
                        pageBreakInside: "avoid",
                        borderCollapse: "collapse",
                      }}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell>Broker Name</TableCell>
                          <TableCell>Total Hours</TableCell>
                          <TableCell>Total Days</TableCell>
                          <TableCell>Open Count</TableCell>
                          <TableCell>Closed Count</TableCell>
                          <TableCell>Late Count</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rollupBrokers && rollupBrokers.length > 0 ? (
                          rollupBrokers.map((val, index) => (
                            <TableRow
                              sx={{
                                "&:last-child td, &:last-child th": {
                                  border: 0,
                                },
                              }}
                            >
                              <TableCell> {val.BrokerName} </TableCell>
                              <TableCell>
                                {val.TotalHours
                                  ? val.TotalHours.toFixed(2)
                                  : "0.00"}
                              </TableCell>
                              <TableCell>
                                {val.TotalDays ? val.TotalDays : 0}{" "}
                              </TableCell>
                              <TableCell>
                                {val.OpenCount ? val.OpenCount : 0}
                              </TableCell>
                              <TableCell>
                                {val.ClosedCount ? val.ClosedCount : 0}
                              </TableCell>
                              <TableCell>
                                {val.LateCount ? val.LateCount : 0}
                              </TableCell>
                            </TableRow>
                          ))
                        ) : (
                          <TableRow>
                            <TableCell colSpan={6} align="center">
                              <Typography>No Record Found</Typography>
                            </TableCell>
                          </TableRow>
                        )}

                        {rollupBrokers && rollupBrokers.length > 0 ? (
                          <TableRow>
                            <TableCell>
                              <strong>Total</strong>
                            </TableCell>
                            <TableCell>
                              <strong>
                                {rollupBrokers
                                  .reduce(
                                    (sum, item) => sum + (item.TotalHours || 0),
                                    0
                                  )
                                  .toFixed(2)}
                              </strong>
                            </TableCell>
                            <TableCell>
                              <strong>
                                {rollupBrokers.reduce(
                                  (sum, item) => sum + (item.TotalDays || 0),
                                  0
                                )}
                              </strong>
                            </TableCell>
                            <TableCell>
                              <strong>
                                {rollupBrokers.reduce(
                                  (sum, item) => sum + (item.OpenCount || 0),
                                  0
                                )}
                              </strong>
                            </TableCell>
                            <TableCell>
                              <strong>
                                {rollupBrokers.reduce(
                                  (sum, item) => sum + (item.ClosedCount || 0),
                                  0
                                )}
                              </strong>
                            </TableCell>
                            <TableCell>
                              <strong>
                                {rollupBrokers.reduce(
                                  (sum, item) => sum + (item.LateCount || 0),
                                  0
                                )}
                              </strong>
                            </TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        ) : (
                          ""
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
                <div
                  id="capturediv2"
                  style={
                    zoomPgae
                      ? {
                          transform: `scale(${zoomPgae / 100 + 1})`,
                          transformOrigin: "0 0",
                        }
                      : {}
                  }
                >
                  {fullPageView === false &&
                  currentPageData &&
                  currentPageData.length > 0
                    ? currentPageData.map((rollupBilling, index) => {
                        const currentUser = `${rollupBilling.UserName} ${rollupBilling.UserEmail} ${rollupBilling.UserPhone}`;
                        const shouldDisplay = lastDisplayedUser !== currentUser;

                        if (shouldDisplay) {
                          lastDisplayedUser = currentUser; // Update the last displayed user
                        }
                        return (
                          <>
                            {shouldDisplay ? (
                              <Typography
                                sx={{
                                  marginBottom: "10px !important",
                                  marginTop: "20px !important",
                                }}
                                key={index}
                                className="broker-preview-title"
                              >
                                {rollupBilling.UserName}{" "}
                                {rollupBilling.UserEmail}{" "}
                                {rollupBilling.UserPhone}
                              </Typography>
                            ) : null}

                            <TableContainer
                              sx={{
                                // minHeight: "300px",
                                borderRadius: "5px",
                                border: "1px solid #EDEDED",
                                mt: "10px",
                                mb: "15px",
                              }}
                              className="preview-table"
                              component={Paper}
                            >
                              <Stack
                                sx={{ padding: "10px 14px" }}
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Typography
                                  className="summary-table-intext"
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <span
                                    style={{
                                      color: "#58A84A",
                                      marginRight: "4px",
                                    }}
                                    class="material-symbols-outlined"
                                  >
                                    calendar_month
                                  </span>
                                  {moment
                                    .utc(rollupBilling.BillingStart)
                                    .format("MM/DD/YYYY")}{" "}
                                  -{" "}
                                  {moment
                                    .utc(rollupBilling.BillingEnd)
                                    .format("MM/DD/YYYY")}
                                </Typography>
                                <Typography className="summary-table-intext">
                                  Statement ID: {rollupBilling.HeaderID} -{" "}
                                  {rollupBilling.BillingStatus}
                                </Typography>
                              </Stack>

                              <Table
                                sx={{
                                  minWidth: 650,
                                  pageBreakInside: "avoid",
                                  borderCollapse: "collapse",
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Hours</TableCell>
                                    {/* <TableCell>Miles</TableCell> */}
                                    <TableCell>Lodging</TableCell>
                                    <TableCell>Copies</TableCell>
                                    <TableCell>Misc</TableCell>
                                    <TableCell></TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {rollupBilling.data &&
                                  rollupBilling.data.length > 0 ? (
                                    rollupBilling.data
                                      .sort(
                                        (a, b) =>
                                          new Date(a.DetailDate) -
                                          new Date(b.DetailDate)
                                      )
                                      .map((rollupBillingData) => (
                                        <TableRow
                                          sx={{
                                            "&:last-child td, &:last-child th":
                                              {
                                                border: 0,
                                              },
                                          }}
                                        >
                                          <TableCell>
                                            <span>
                                              {rollupBillingData.DetailDate
                                                ? moment
                                                    .utc(
                                                      rollupBillingData.DetailDate
                                                    )
                                                    .format("MM/DD/YYYY")
                                                : "--"}
                                            </span>
                                            <br />
                                            <span
                                              style={{ lineBreak: "anywhere" }}
                                              className="pv-discription"
                                            >
                                              {rollupBillingData.Description ||
                                                "No Description"}
                                            </span>
                                          </TableCell>
                                          <TableCell>
                                            {rollupBillingData.BillingType}
                                          </TableCell>
                                          <TableCell>
                                            {rollupBillingData.DetailHours.toFixed(
                                              2
                                            )}
                                          </TableCell>
                                          <TableCell>
                                            {"$"}
                                            {rollupBillingData.Lodging
                                              ? rollupBillingData.Lodging.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </TableCell>
                                          <TableCell>
                                            {"$"}
                                            {rollupBillingData.Copies
                                              ? rollupBillingData.Copies.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </TableCell>
                                          <TableCell>
                                            {"$"}
                                            {rollupBillingData.Misc
                                              ? rollupBillingData.Misc.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </TableCell>
                                          {/* <TableCell>
                                          {rollupBillingData.Miles
                                            ? rollupBillingData.Miles.toFixed(2)
                                            : "0.00"}
                                        </TableCell> */}
                                        </TableRow>
                                      ))
                                  ) : (
                                    <TableRow>
                                      <TableCell colSpan={8} align="center">
                                        <Typography>No Record Found</Typography>
                                      </TableCell>
                                    </TableRow>
                                  )}

                                  {rollupBilling.data &&
                                  rollupBilling.data.length > 0 ? (
                                    <TableRow>
                                      <TableCell>
                                        <strong>Total</strong>
                                      </TableCell>
                                      <TableCell></TableCell>
                                      <TableCell>
                                        <strong>
                                          {rollupBilling.data
                                            .reduce(
                                              (sum, item) =>
                                                sum + (item.DetailHours || 0),
                                              0
                                            )
                                            .toFixed(2)}
                                        </strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>
                                          {"$" +
                                            rollupBilling.data
                                              .reduce(
                                                (sum, item) =>
                                                  sum + (item.Lodging || 0),
                                                0
                                              )
                                              .toFixed(2)}
                                        </strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>
                                          {"$" +
                                            rollupBilling.data
                                              .reduce(
                                                (sum, item) =>
                                                  sum + (item.Copies || 0),
                                                0
                                              )
                                              .toFixed(2)}
                                        </strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>
                                          {"$" +
                                            rollupBilling.data
                                              .reduce(
                                                (sum, item) =>
                                                  sum + (item.Misc || 0),
                                                0
                                              )
                                              .toFixed(2)}
                                        </strong>
                                      </TableCell>
                                      {/* <TableCell>
                                      {"$" +
                                        rollupBilling.data
                                          .reduce(
                                            (sum, item) =>
                                              sum + (item.Miles || 0),
                                            0
                                          )
                                          .toFixed(2)}
                                    </TableCell> */}
                                      <TableCell></TableCell>
                                    </TableRow>
                                  ) : (
                                    ""
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </>
                        );
                      })
                    : rollupBillingDetails && rollupBillingDetails.length > 0
                    ? rollupBillingDetails.map((rollupBilling, index) => {
                        const currentUser = `${rollupBilling.UserName} ${rollupBilling.UserEmail} ${rollupBilling.UserPhone}`;
                        const shouldDisplay = lastDisplayedUser !== currentUser;

                        if (shouldDisplay) {
                          lastDisplayedUser = currentUser; // Update the last displayed user
                        }
                        return (
                          <>
                            {shouldDisplay ? (
                              <Typography
                                sx={{ margin: "12px 0px !important" }}
                                key={index}
                                className="broker-preview-title"
                              >
                                {rollupBilling.UserName}{" "}
                                {rollupBilling.UserEmail}{" "}
                                {rollupBilling.UserPhone}
                              </Typography>
                            ) : null}

                            <TableContainer
                              sx={{
                                // minHeight: "300px",
                                borderRadius: "5px",
                                border: "1px solid #EDEDED",
                                mt: "10px",
                                mb: "15px",
                              }}
                              className="preview-table"
                              component={Paper}
                            >
                              <Stack
                                sx={{ padding: "10px 14px" }}
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Typography
                                  className="summary-table-intext"
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <span
                                    style={{
                                      color: "#58A84A",
                                      marginRight: "4px",
                                    }}
                                    class="material-symbols-outlined"
                                  >
                                    calendar_month
                                  </span>
                                  {moment
                                    .utc(rollupBilling.BillingStart)
                                    .format("MM/DD/YYYY")}{" "}
                                  -{" "}
                                  {moment
                                    .utc(rollupBilling.BillingEnd)
                                    .format("MM/DD/YYYY")}
                                </Typography>
                                <Typography className="summary-table-intext">
                                  Statement ID: {rollupBilling.HeaderID} -{" "}
                                  {rollupBilling.BillingStatus}
                                </Typography>
                              </Stack>
                              <Table
                                sx={{
                                  minWidth: 650,
                                  pageBreakInside: "avoid",
                                  borderCollapse: "collapse",
                                }}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Date</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Hours</TableCell>
                                    {/* <TableCell>Miles</TableCell> */}
                                    <TableCell>Lodging</TableCell>
                                    <TableCell>Copies</TableCell>
                                    <TableCell>Misc</TableCell>
                                    <TableCell></TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {rollupBilling.data &&
                                  rollupBilling.data.length > 0 ? (
                                    rollupBilling.data
                                      .sort(
                                        (a, b) =>
                                          new Date(a.DetailDate) -
                                          new Date(b.DetailDate)
                                      )
                                      .map((rollupBillingData) => (
                                        <TableRow
                                          sx={{
                                            "&:last-child td, &:last-child th":
                                              {
                                                border: 0,
                                              },
                                          }}
                                        >
                                          <TableCell>
                                            <span>
                                              {rollupBillingData.DetailDate
                                                ? moment
                                                    .utc(
                                                      rollupBillingData.DetailDate
                                                    )
                                                    .format("MM/DD/YYYY")
                                                : "--"}
                                            </span>
                                            <br />
                                            <span
                                              style={{ lineBreak: "anywhere" }}
                                              className="pv-discription"
                                            >
                                              {rollupBillingData.Description ||
                                                "No Description"}
                                            </span>
                                          </TableCell>
                                          <TableCell>
                                            {rollupBillingData.BillingType}
                                          </TableCell>
                                          <TableCell>
                                            {rollupBillingData.DetailHours}
                                          </TableCell>
                                          <TableCell>
                                            {"$"}
                                            {rollupBillingData.Lodging
                                              ? rollupBillingData.Lodging.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </TableCell>
                                          <TableCell>
                                            {"$"}
                                            {rollupBillingData.Copies
                                              ? rollupBillingData.Copies.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </TableCell>
                                          <TableCell>
                                            {"$"}
                                            {rollupBillingData.Misc
                                              ? rollupBillingData.Misc.toFixed(
                                                  2
                                                )
                                              : "0.00"}
                                          </TableCell>
                                          {/* <TableCell>
                                          {rollupBillingData.Miles
                                            ? rollupBillingData.Miles.toFixed(2)
                                            : "0.00"}
                                        </TableCell> */}
                                        </TableRow>
                                      ))
                                  ) : (
                                    <TableRow>
                                      <TableCell colSpan={8} align="center">
                                        <Typography>No Record Found</Typography>
                                      </TableCell>
                                    </TableRow>
                                  )}

                                  {rollupBilling.data &&
                                  rollupBilling.data.length > 0 ? (
                                    <TableRow>
                                      <TableCell>
                                        <strong>Total</strong>
                                      </TableCell>
                                      <TableCell></TableCell>
                                      <TableCell>
                                        <strong>
                                          {rollupBilling.data.reduce(
                                            (sum, item) =>
                                              sum + (item.DetailHours || 0),
                                            0
                                          )}
                                        </strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>
                                          {"$" +
                                            rollupBilling.data
                                              .reduce(
                                                (sum, item) =>
                                                  sum + (item.Lodging || 0),
                                                0
                                              )
                                              .toFixed(2)}
                                        </strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>
                                          {"$" +
                                            rollupBilling.data
                                              .reduce(
                                                (sum, item) =>
                                                  sum + (item.Copies || 0),
                                                0
                                              )
                                              .toFixed(2)}
                                        </strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>
                                          {"$" +
                                            rollupBilling.data
                                              .reduce(
                                                (sum, item) =>
                                                  sum + (item.Misc || 0),
                                                0
                                              )
                                              .toFixed(2)}
                                        </strong>
                                      </TableCell>
                                      {/* <TableCell>
                                      {"$" +
                                        rollupBilling.data
                                          .reduce(
                                            (sum, item) =>
                                              sum + (item.Miles || 0),
                                            0
                                          )
                                          .toFixed(2)}
                                    </TableCell> */}
                                      <TableCell></TableCell>
                                    </TableRow>
                                  ) : (
                                    ""
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </>
                        );
                      })
                    : ""}
                  <Typography className="address-bar">
                    © 2024. HOS Resources, LLC. All Rights Reserved. 910 Harding
                    Street Lafayette, LA 70503 337-296-8032 www.hosresources.com
                  </Typography>
                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="flex-start"
                    justifyContent="space-between"
                    className="preview-footer"
                  >
                    <Box>
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="flex-start"
                      >
                        <span class="material-symbols-outlined">
                          location_on
                        </span>
                        <Typography>
                          910 Harding Street <br />
                          Lafayette, LA 70503
                        </Typography>
                      </Stack>
                    </Box>
                    <Box>
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="flex-start"
                      >
                        <span class="material-symbols-outlined">mail</span>
                        <Typography>
                          P.O. Box 51794 <br />
                          Lafayette, LA 70505
                        </Typography>
                      </Stack>
                    </Box>
                    <Box>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <span class="material-symbols-outlined">call</span>
                        <Typography>337.889.3941</Typography>
                      </Stack>
                    </Box>
                    <Box>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <span class="material-symbols-outlined">public</span>
                        <Typography>www.hosresources.com</Typography>
                      </Stack>
                    </Box>
                  </Stack>
                </div>
              </div>
            </div>
            {loading && <CustomPageLoading />}
          </Box>
        </Box>
      </Box>
    </div>
  );
}
